// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1vRod","errorLogs":"styles_errorLogs__23p-7"};